import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { Icon } from '../../components';
import Theme from '../../theme';

const CheckBoxShoppingList = ({
  isActive,
  size = 30,
  onPress,
}) => {

  const activeCheckboxStyle = {
    backgroundColor: Theme.PRIMARY,
  };
  const inActiveCheckboxStyle = {
    backgroundColor: Theme.GREY_MEDIUM_LIGHT,
  };

  return (
    <TouchableOpacity style={[
      styles.checkboxContainer, {
        width: size,
        height: size,
      },
      isActive ? activeCheckboxStyle : inActiveCheckboxStyle ]}
                      onPress={onPress}>
      {isActive &&
        <Icon
          size={size - 10}
          style={styles.iconStyle}
          name="md-checkmark"
          color={Theme.WHITE}
        />
      }
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  checkboxContainer: {
    borderRadius: 3,
    marginRight: 10,
    marginTop: 5,
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    // borderColor: Theme.PRIMARY,
  },
  iconStyle: {
    fontFamily: Theme.Custom800,
    fontSize: 13,
    fontWeight: "bold",
  }
});

export default CheckBoxShoppingList;
